var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CallLog } from 'packages/call_logs/CallLog';
import { AbstractRepository } from 'packages/core/AbstractRepository';
import ENV from 'config/env';
var CallLogRepository = /** @class */ (function (_super) {
    __extends(CallLogRepository, _super);
    function CallLogRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = CallLog;
        _this.url = 'jobs/:job/talent/:talent/logs';
        _this.baseUrl = ENV.JOBILLA_API_ROOT + "v5/";
        return _this;
    }
    CallLogRepository.prototype.list = function (talentId, jobId) {
        return this.getAll(this.url, { talent: talentId, job: jobId });
    };
    return CallLogRepository;
}(AbstractRepository));
export { CallLogRepository };
